import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

/**
 * Proveedores globales del portal del cliente.
 *
 * Sólo la caché de React Query: a diferencia del panel, aquí no hay sesión de
 * operador ni catálogo de módulos que precargar. El `SessionProvider` de la capa
 * HTTP tampoco se registra: el token del portal lo pone `portal.api.ts`.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
